import React from "react";

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  eyebrow?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

/** Standard page heading: optional eyebrow, title, supporting copy and actions. */
export const PageHeader = ({ title, subtitle, eyebrow, actions, className = "" }: PageHeaderProps) => (
  <header className={`zs-page-header ${className}`}>
    <div className="min-w-0">
      {eyebrow && <div className="zs-eyebrow">{eyebrow}</div>}
      <h1 className="zs-page-title">{title}</h1>
      {subtitle && <p className="zs-page-subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </header>
);
